import { render, staticRenderFns } from "./MessageBoard.vue?vue&type=template&id=74c66f37&scoped=true"
import script from "./MessageBoard.vue?vue&type=script&lang=js"
export * from "./MessageBoard.vue?vue&type=script&lang=js"
import style0 from "./MessageBoard.vue?vue&type=style&index=0&id=74c66f37&prod&lang=stylus&scoped=true"
import style1 from "./MessageBoard.vue?vue&type=style&index=1&id=74c66f37&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c66f37",
  null
  
)

export default component.exports